<template>
  <path
    d="M12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 12 2.00024ZM16 13.0002H8C7.45 13.0002 7 12.5502 7 12.0002C7 11.4502 7.45 11.0002 8 11.0002H16C16.55 11.0002 17 11.4502 17 12.0002C17 12.5502 16.55 13.0002 16 13.0002Z"
  />
</template>
